"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../theme");
var useStyles = (0, _theme.makeStyles)({
  fullWidth: {
    width: '100%',
    justifyContent: 'space-between',
    margin: 0
  }
}, {
  name: 'Checkbox'
});
exports.useStyles = useStyles;